const styles = (theme) => ({
    header: {
        fontSize: '16px',
        color: 'black'
    },
    category: {
        marginTop: '20px'
    },
    inputRoot: {
        border: '1px solid grey',
        borderRadius: '20px',
        padding: '10px 15px',
        margin: '10px 0',
        background: 'none',
        '&:focus': {
            borderRadius: '20px',
            background: 'none',
        }
    },
    description: {
        width: '100%',
        padding: '5px',
        borderRadius: '5px',
        marginBottom: '10px'
    },
    label: {
        fontSize: '14px'
    }
});

export default styles;
